var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-popup"},[(_vm.onCloseClick)?_c('img',{staticClass:"close-icon",attrs:{"src":"/static/close-popup.svg","alt":"Close"},on:{"click":_vm.onCloseClick}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }